import { r1, r2, projectmgmt, shipping, repairs, purchasing, facebook, instagram, linkedin, youtube, whatsapp, tiktok, rimsa, smartsimple, reanimed, detes, biobase, send, shield, star  } from "../assets";


export const navLinks = [
  {
    id: "home",
    title: "Home",
    href: "/",
  },
  {
    id: "products",
    title: "Products",
    href: "/products",
  },
  {
    id: "expertise",
    title: "Expertise",
    href: "/expertise", 
  },
  {
  id: "training",
  title: "Training",
  path: "/training"
  },
  {
    id: "company",
    title: "Company",
    href: "/company",
  },
  {
    id: "support",
    title: "Support",
    href: "/support",
  },
  {
    id: "contact",
    title: "Contact",
    href: "/contact",
  },
];

export const features = [
  {
    id: "feature-1",
    icon: star,
    title: "Consultancy Services",
    content:
      "We offer medical training, servicing and repairs and research.",
  },
  {
    id: "feature-2",
    icon: shield,
    title: "Medical Equipment",
    content:
      "We offer a variety of medical equipment to medical facilities all over Sub-Saharan Africa.",
  },
  {
    id: "feature-3",
    icon: send,
    title: "Over The Counter(OTC) Devices",
    content:
      "We offer medical products that have established safety profiles for use by consumers in non-clinical environments.",
  },
];

export const feedback = [
  {
    id: "feedback-1",
    content:
      "..",
    name: "Anaesthesia Machine S6100_1 ",
    title: "Lab",
    img: "..",
  },
  {
    id: "feedback-2",
    content:
      "..",
    name: "Anaesthesia Machine S6100_1",
    title: "Medical Gases",
    img: "..",
  },
  {
    id: "feedback-3",
    content:
      "..",
    name: "Anaesthesia Machine S6100_1",
    title: "Theatre",
    img: "..",
  },
];

export const stats = [
  {
    id: "stats-1",
    title: "Precision In Healthcare",
    
  },
];

export const footerLinks = [
  {
    title: "Products",
    links: [
      {
        name: "Medical Gases | Piping",
        href: "/Products",
      },
      {
        name: "Dental",
        href: "/Products",
      },
      {
        name: "Radiology",
        link: "/Products",
      },
      {
        name: "Theatre | Hospital Furniture",
        href: "/Products",
      },
      {
        name: "CSSD Equipment",
        href: "/Products",
      },
    ],
  },
  {
    title: "Company",
    links: [
      {
        name: "Home",
        href: "/Home",
      },
      {
        name: "Company",
        href: "/Company",
      },
      {
        name: "Products",
        href: "/Products",
      },
      {
        name: "Expertise",
        href: "/Expertise",
      },
      {
        name: "Contact",
        link: "/Contact",
      },
      {
        name: "Support",
        href: "/Support",
      },
    ],
  },
  {
    title: "Legal",
    links: [
      {
        name: "Terms & Services",
        href: "/Support",
      },
      {
        name: "Terms of Use",
        href: "/Support",
      },
      {
        name: "Refund Policy",
        href: "/Support",
      },
      
    ],
  },
  {
    title: "Quick Links",
    links: [
      {
        name: "Full Catalogue",
        href: "/products",
      },
      {
        name: "Become a Partner",
        href: "/contact",
      },
    ],
  },
];

export const socialMedia = [
  {
    id: "social-media-1",
    icon: whatsapp,
    link: "https://wa.me/+255792996709",
  },
  {
    id: "social-media-2",
    icon: facebook,
    link: "https://www.facebook.com/share/1C5EPdx29d/",
  },
  {
    id: "social-media-3",
    icon: instagram,
    link: "https://www.instagram.com/hosphcare_solutions_tz?utm_source=qr&igsh=MXZ5MTF2aGQ1d3owMw==",
  },
  {
    id: "social-media-4",
    icon: youtube,
    link: "https://youtube.com/@hosphcaresolutionstzlimited?si=z0WfVbts9IDy4cj7",
  },
  {
    id: "social-media-5",
    icon: linkedin,
    link: "https://www.linkedin.com/company/hosphcare-solutions-tz-limited/",
  },
  {
    id: "social-media-5",
    icon: tiktok,
    link: "https://www.tiktok.com/@hosphcaresolutions",
  },
];

export const creator = [
  {
    id: "creator",
    link: "https://github.com/wangunda",
  },
];

export const clients = [
  {
    id: "client-1",
    logo: rimsa,
  },
  {
    id: "client-2",
    logo: smartsimple,
  },
  {
    id: "client-3",
    logo:  reanimed,
  },
  {
    id: "client-4",
    logo: detes,
  },
  {
    id: "client-5",
    logo: biobase,
  },
];

export const anaesthesia = [
  {
    id: "01",
    img: r1,
    name: "Anaesthesia Machine S6100_1 ",
    
  },
  {
    id: "01",
    img: r2,
    name: "Anaesthesia Machine S6100_1 ",
    
  },

];

export const experiences = [
  {
    title: "Sales",
    date: "March 2020 - Present",
    points: [
      "We understand that every project is unique and we take pride in our ability to tailor our solutions to meet specific needs of our clients with integrity and excellence.",
    ],
  },
  {
    title: "Procurement",
    date: "Jan 2021 - Present",
    points: [
      "With deep insights into the unmet clinical needs in Tanzania, HSL aims to provide You with comprehensive healthcare solutions and support.",
    ],
  },
  {
    title: "Specialists",
    date: "Jan 2025 - Present",
    points: [
      "We beleive in the power of engineering to transform ideas into tangible realities.",
      "We are driven by a passion for delivering exceptional, structural and mechanical solutions that exceed expectations",
    ]
  },
  {
    title: "Other Services",
    date: "Present",
    points: [
      "HSL has a technical service team that supports its products, from in-service training through to complete operating table rebuilds.",
      "HSL installs equipment, lights, pendants, digital integration, sterilizers Dental, Medical Gases and more.",
      "Also project manages complete medical fit-outs.",
    ],
  },
];

const featuresData = [
  {
    image: shipping,
    title: "Sub-Saharan Delivery",
    desc: "We offer delivery of equipment across East African and the Sub-Saharan Region.",
  },
  {
    image: purchasing,
    title: "Safe Payment",
    desc: "We offer competitive prices on our products at any range.",
  },
  {
    image: projectmgmt,
    title: "Shop With Confidence ",
    desc: "We offer safe and quality assurance on all our products.",
  },
  {
    image: repairs,
    title: "24/7 Support ",
    desc: "We offer maintenance and support 24/7.",
  },
];
export default featuresData;





